import React from "react";
import "../styles/MapSection.css";

function MapSection({ onFindNearest, loading, mapsApiLoaded }) {
    return (
        <section className="map-section" id="showroom">
            <div className="map-container">
                <iframe
                    src="https://www.google.com/maps/d/embed?mid=18d2PEpQV8siZdUX2lGeP27qeZp63pN8&ehbc=2E312F&noprof=1"
                    width="100%"
                    height="500"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="Bản đồ Trạm Dịch Vụ"
                ></iframe>
                {mapsApiLoaded && (
                    <div className="map-api-status api-loaded">
                        Google Maps API đã sẵn sàng
                    </div>
                )}
            </div>
            <div className="find-nearest">
                <button
                    onClick={onFindNearest}
                    disabled={loading}
                    className="find-btn"
                >
                    {loading ? (
                        <>
                            <span className="spinner"></span>
                            Đang tìm...
                        </>
                    ) : (
                        "Tìm Trạm Dịch Vụ Gần Nhất"
                    )}
                </button>
                {!mapsApiLoaded && (
                    <div className="api-status-message">
                        <span className="api-loading">Đang tải Google Maps API...</span>
                    </div>
                )}
            </div>
        </section>
    );
}

export default MapSection;
